import { render, staticRenderFns } from "./advantageService.vue?vue&type=template&id=b188c30a&scoped=true"
import script from "./advantageService.vue?vue&type=script&lang=js"
export * from "./advantageService.vue?vue&type=script&lang=js"
import style0 from "./advantageService.vue?vue&type=style&index=0&id=b188c30a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b188c30a",
  null
  
)

export default component.exports